var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.newsDetail.content),expression:"newsDetail.content"}],staticClass:"isDiv",domProps:{"innerHTML":_vm._s(_vm.newsDetail.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }